import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import {firebaseConfig} from "./firebase-config";

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseApp);
